export default __webpack_public_path__ + "static/run-4cdc3828289c65b145f1f029e68ab04e.png";